import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../../hooks/useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { IRulesetUpdateParams } from '../../../types/ruleset-types';

interface UpdateRulesetParams {
  dataPoolId: string;
  rulesetId: string;
  data: IRulesetUpdateParams;
}

export function useUpdateRuleset(callbacks?: IRQCallbacks) {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ dataPoolId, rulesetId, data }: UpdateRulesetParams) =>
      (await glynt).ruleset.update(dataPoolId, rulesetId, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['rulesets', variables.dataPoolId] });
      callbacks?.onSuccess?.(data);
    },
    onError: callbacks?.onError,
    onMutate: callbacks?.onMutate,
    onSettled: callbacks?.onSettled,
  });
}
